module.exports = __webpack_public_path__ + "static/manual_of_bodily_health-c4f22d2374fdb1e0086f1e25110fa5a0.jpeg";